// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c81o8v{font:var(--ds-font-body-small,normal 400 11px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._lcxv1wug{pointer-events:auto}\n._o5721jtm{white-space:pre-wrap}\n._syaz1rpy{color:var(--ds-text-subtlest,#6b6e76)}", ""]);
// Exports
module.exports = exports;
